module.exports = __webpack_public_path__ + "img/lk.d9a0006d.jpg";